import { render, staticRenderFns } from "./com-empty.vue?vue&type=template&id=199ded68&scoped=true"
import script from "./com-empty.vue?vue&type=script&lang=ts"
export * from "./com-empty.vue?vue&type=script&lang=ts"
import style0 from "./com-empty.vue?vue&type=style&index=0&id=199ded68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199ded68",
  null
  
)

export default component.exports